enum ResidencyStatus {
  AustralianResident,
  ForeignResident,
  WorkingHolidayMaker
};

export default ResidencyStatus;